import {
    Box,
    Center,
    useColorModeValue,
    Heading,
    useColorMode,
    Text,
    Stack,
    Image,
    Badge,
  } from '@chakra-ui/react';
  import data from '../Pages/Techskill';
  import "aos/dist/aos.css"
  import Aos from 'aos'

import { useEffect } from 'react';
// export interface data{
//   img:string;
//   name:string;
// }

export default function Card({i,img,name}=data) {
    useEffect(() => {
      Aos.init({duration:500})
     
    }, [])
  const { colorMode, toggleColorMode } = useColorMode();
    
    return (
      <Center py={12} cursor={'pointer'} className="github-stats">
        <Box
        
        
        
        data-aos="flip-left"
        key={i}
          role={'group'}
         
          p={6}
          maxW={'330px'}
          w={'contain'}
          bg={useColorModeValue('white', 'gray.800')}
          boxShadow={'2xl'}
          rounded={'lg'}
          pos={'relative'}
          height={"150px"}
          zIndex={1}>
            

          <Box
            rounded={'lg'}
            mt={-12}
            pos={'relative'}
            height={'200px'}
            _after={{
              transition: 'all .3s ease',
              content: '""',
              w: 'full',
              h: 'full',
              pos: 'absolute',
              top: 5,
              left: 0,
              // backgroundImage: `url(${img})`,
              // filter: 'blur(15px)',
              zIndex: -1,
            }}
            _groupHover={{
              _after: {
                // filter: 'blur(20px)',
              },
            }}>
            <Image
              rounded={'lg'}
              height={230}
              width={282}
              objectFit={'cover'}
              src={img}
              class="skills-card-img"
            />
            <Stack pt={10} align={'center'}>
        
            <Heading fontSize={'2xl'} fontFamily={'body'} fontWeight={500}>
             
             <Badge variant='outline' color={colorMode==="light"?"black":"white"} padding={"5px"}  colorScheme='purple' fontSize={"20px"} class="skills-card-name">{name}</Badge>
            </Heading>
          </Stack>
          </Box>
        </Box>
      </Center>
    );
  }